import React from 'react';
import { SERVICE_PAGE } from '../../lib/queries';
import client from '../../lib/apolloClient';
import Layout from '../../src/components/Layout/Layout';
import Hero from '../../src/components/Services/Hero/Hero';
import Body from '../../src/components/Services/Body/Body';
import replacePictureUrlWithSignedUrl from '../../src/utils/replaceUrlWithSigned/replaceUrlWithSigned';

const Services = (props) => {
  const { data, pid } = props;

  return (
    <Layout hero={<Hero data={data.services[0]} />} whiteTextColor>
      <Body data={data.services[0]} pid={pid} />
    </Layout>
  );
};

export default Services;

export async function getServerSideProps(context) {
  const { pid } = context.query;
  let { data } = await client.query({
    query: SERVICE_PAGE,
    variables:
     { where: { linkAddress: pid } },
  });
  data = await replacePictureUrlWithSignedUrl(data);
  if (data && data.services.length > 0) {
    return {
      props: { data, pid },
    };
  }
  return {
    notFound: true,
  };
}
